import {
  FAQSection,
  HowItWorksSearch,
  MoreWaysToUseGcx,
  ShopNowList
} from "components/UI/organisms";
import { DownloadMobileApp, VisitHelpCenter } from "components/UI/molecules";
import { HOW_IT_WORKS_FAQ } from "./utils/content";
import "./index.scss";

export const HowItWorks = () => {
  return (
    <>
      <section className="search-page-container">
        <h1 className="search-title">Join GCX to save thousands each year.</h1>
        <h2 className="search-subtitle">
          Whether you’re looking to save on your next meal, or a new kitchen, or
          a dream vacation, pay with gift cards to{" "}
          <strong className="strong-save-money">save money everywhere</strong>{" "}
          you shop.
        </h2>
        <HowItWorksSearch />
      </section>
      <ShopNowList />
      <DownloadMobileApp />
      <FAQSection faqList={HOW_IT_WORKS_FAQ} />
      <MoreWaysToUseGcx />
      <VisitHelpCenter />
    </>
  );
};
